module.exports = __webpack_public_path__ + "static/media/ES-Upv.2141b3da.png";